import { useQuery } from '@tanstack/react-query';
import { timeOffAPI } from '../services/api';

export const useUpcomingVacations = () => {
  return useQuery({
    queryKey: ['upcomingVacations'],
    queryFn: timeOffAPI.getUpcoming,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
};

